// mock this externalState.ts to render the react view without worrying business about logic
import { computed, state } from 'ccstate'
import { apiClient$ } from './apiClient'

export const allArticles_dirty$ = state(1)

export const allArticles$ = computed(async (get) => {
  get(allArticles_dirty$)
  const apiClient = get(apiClient$)
  const result = await apiClient.getApi('getAllArticles', {})
  return result.data
})